import React, { FC } from 'react';
import styles from './styles.module.css';
import { Asset, Button, InfoFilledIcon } from '@clearcover/atlas';
import { StaggeredAnimatedComponent } from 'Policies/components';
import classnames from 'classnames';
import { HRule } from '../HRule';

type PageHeaderProps = {
  onActionClick?: () => void;
  actionName?: string;
  actionTestId?: string;
  heading: string;
};

export const PageHeader: FC<PageHeaderProps> = ({
  onActionClick,
  actionTestId,
  actionName,
  heading,
}) => {
  return (
    <>
      <div className={styles.pageHeader}>
        <h1>{heading}</h1>
        {actionName && (
          <div className={styles.actionBtn}>
            <Button
              data-testid={actionTestId}
              variant="primary"
              isSubmitting={false}
              onClick={onActionClick}
            >
              {actionName}
            </Button>
          </div>
        )}
      </div>
      <HRule size={actionName ? 'sm' : 'lg'} />
    </>
  );
};

export const PageHeaderBar: FC<{
  className?: string;
  children?: React.ReactNode;
}> = ({ className, children }) => {
  return (
    <StaggeredAnimatedComponent
      className={classnames(styles.container, className)}
    >
      {children}
    </StaggeredAnimatedComponent>
  );
};

export const AchHeaderBar: FC = () => {
  return (
    <StaggeredAnimatedComponent
      className={classnames(
        styles.container,
        styles.achBannerContainer,
        'header-bar'
      )}
    >
      <div className={styles.achInfo}>
        <Asset
          icon={InfoFilledIcon}
          description="Information icon"
          height={20}
          width={20}
          className={styles.achInfoIcon}
        />
        Agency Managed
      </div>
      <div>
        This policy is managed by Ocho Agency. Customers should contact an Ocho
        agent for any policy changes or to make payments.{' '}
        <a
          href="https://app.ocho.co/sign-in"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.continue}
        >
          Learn More
        </a>
      </div>
    </StaggeredAnimatedComponent>
  );
};
